<div class="chat-date-of-birth" [class.chat-date-of-birth--locked]="locked">
  @if (showLabel) {
    <div class="chat-date-of-birth__label">
      Date of birth for {{ passengerName }}
      @if (isMandatory) {
        <span class="chat-date-of-birth__required" aria-hidden="true">*</span>
      }
    </div>
  }
  @if (locked || chosenSummary) {
    <div class="chat-date-of-birth__chosen">{{ chosenSummary || dateOfBirth }}</div>
  } @else {
    <input
      class="chat-date-of-birth__control"
      type="date"
      [(ngModel)]="dateOfBirth"
      aria-label="Date of birth"
    />
    <div class="chat-date-of-birth__actions">
      @if (!isMandatory) {
        <button type="button" class="chat-date-of-birth__skip" (click)="onSkip()">Skip</button>
      }
      <button
        type="button"
        class="chat-date-of-birth__continue"
        [disabled]="!isValid"
        (click)="onContinue()"
      >
        Continue
      </button>
    </div>
  }
</div>
